import React, { Component } from "react";
import { connect } from 'react-redux';
import moment from 'moment';
import { sortPostsByDate } from '../selectores/posts';
import { fetchPosts } from '../actions/posts';



export class PostList extends Component {

  constructor(props) {
    super(props); 
    this.state = {}
  }

  componentWillMount() {
    try {
       this.props.fetchPosts();
    } catch (e) {
      this.setState({ error: e.message });
    }
  }

  handleFetchStatus() {
    if (this.state.error) {
      return (
        <div className="col">
          <p className="text-monospace alert-danger text-center">
            {this.state.error}
          </p>
        </div>
      );
    } else {
      return (
        <div className="col">
          <p className="text-monospace loading-text text-center">
            Fetching posts...
          </p>
        </div>
      );
    }
  };

  renderMainImage(cover) {
    if (cover) {
      return (
        <img src={cover} className="card-img-top img-fluid" alt=".."/>
      );
    }
  }

  render() {
    return (
      <div className="container">
        <div className="row">
              {this.props.posts
                ? this.props.posts.map(post => {
                    return (
                      <div className="col-md-4 col-xs-12 p-1">
                        <div  className="card">
                          {this.renderMainImage(post.cover_image)}
                          <div className="card-body">
                            <h4 className="card-title">{post.title}</h4>
                            <h6 className="card-subtitle text-muted mb-3">
                              {moment(post.created_at).format('MMM Do YYYY')}
                            </h6>
                            <p className="card-text"> {post.description} </p>
                            <a href={post.url}  class="stretched-link" target="_blank" rel="noopener noreferrer" />
                          </div>
                        </div>
                      </div>
                    );
                  })
                : this.handleFetchStatus()}
        </div>
      </div>
    );
  }
  
}

function mapStateToProps(state) {
  return { posts: sortPostsByDate(state.posts.all)};
}

export default connect(mapStateToProps, { fetchPosts })(PostList);



// WEBPACK FOOTER //
// ./src/components/PostList.js